/* Aitomatto product barcode – delegated events survive Shopify Horizon view transitions. */
(() => {
  'use strict';
  if (window.__aitBarcodeInstalled) return;
  window.__aitBarcodeInstalled = true;
  const PATTERNS = '212222,222122,222221,121223,121322,131222,122213,122312,132212,221213,221312,231212,112232,122132,122231,113222,123122,123221,223211,221132,221231,213212,223112,312131,311222,321122,321221,312212,322112,322211,212123,212321,232121,111323,131123,131321,112313,132113,132311,211313,231113,231311,112133,112331,132131,113123,113321,133121,313121,211331,231131,213113,213311,213131,311123,311321,331121,312113,312311,332111,314111,221411,431111,111224,111422,121124,121421,141122,141221,112214,112412,122114,122411,142112,142211,241211,221114,413111,241112,134111,111242,121142,121241,114212,124112,124211,411212,421112,421211,212141,214121,412121,111143,111341,131141,114113,114311,411113,411311,113141,114131,311141,411131,211412,211214,211232,2331112'.split(',');
  const NS = 'http://www.w3.org/2000/svg';

  function getVariants(root) {
    try { return JSON.parse(root.querySelector('[data-ait-barcode-variants]')?.textContent || '{}'); }
    catch (_) { return {}; }
  }
  function getVariantId(root, variants) {
    const urlId = new URLSearchParams(location.search).get('variant');
    if (urlId && variants[urlId]) return urlId;
    const scope = root.closest('[data-testid="product-information"]') || document;
    const fields = scope.querySelectorAll('form[action*="/cart/add"] input[name="id"], product-form-component input[name="id"], input[name="id"]');
    for (const input of fields) if (variants[input.value]) return input.value;
    return Object.keys(variants)[0];
  }
  function makeRect(svg, x, w, height, color) {
    const rect = document.createElementNS(NS, 'rect');
    rect.setAttribute('x', String(x));
    rect.setAttribute('y', '0');
    rect.setAttribute('width', String(w));
    rect.setAttribute('height', String(height));
    rect.setAttribute('fill', color);
    svg.appendChild(rect);
  }
  function drawBarcode(root, rawValue) {
    const svg = root.querySelector('[data-ait-barcode-svg]');
    const label = root.querySelector('[data-ait-barcode-number]');
    if (!svg || !label) return;
    const value = String(rawValue || '').trim();
    svg.replaceChildren();
    label.textContent = value || 'Tuotteella ei ole viivakoodia tai SKU-tunnusta';
    if (!value || !/^[\x20-\x7e]+$/.test(value)) {
      if (value) label.textContent = value + ' – viivakoodin muodostus ei onnistu';
      svg.removeAttribute('viewBox');
      return;
    }
    const codes = [104, ...Array.from(value, ch => ch.charCodeAt(0) - 32)];
    let checksum = 104;
    for (let i = 1; i < codes.length; i++) checksum += codes[i] * i;
    codes.push(checksum % 103, 106);
    if (!codes.every(c => PATTERNS[c])) {
      label.textContent = 'Viivakoodia ei voitu muodostaa';
      return;
    }
    const width = codes.reduce((acc, c) => acc + [...PATTERNS[c]].reduce((sum, d) => sum + Number(d), 0), 20);
    svg.setAttribute('viewBox', '0 0 ' + width + ' 90');
    svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
    makeRect(svg, 0, width, 90, '#ffffff');
    let x = 10;
    for (const code of codes) {
      const bars = PATTERNS[code];
      for (let i = 0; i < bars.length; i++) {
        const w = Number(bars[i]);
        if (i % 2 === 0) makeRect(svg, x, w, 90, '#111111');
        x += w;
      }
    }
  }
  function update(root, forcedId) {
    const variants = getVariants(root);
    const id = forcedId && variants[forcedId] ? forcedId : getVariantId(root, variants);
    const selected = variants[id];
    const trigger = root.querySelector('[data-ait-barcode-open]');
    if (!trigger) return;
    if (!selected) {
      drawBarcode(root, root.dataset.defaultCode || '');
      return;
    }
    const code = String(selected.barcode || selected.sku || '').trim();
    trigger.hidden = !code;
    const subtitle = root.querySelector('[data-ait-barcode-variant]');
    if (subtitle) subtitle.textContent = selected.title === 'Default Title' ? '' : (selected.title || '');
    const img = root.querySelector('[data-ait-barcode-image]');
    if (img && selected.image) img.src = selected.image;
    drawBarcode(root, code);
  }
  function open(root) {
    const dialog = root.querySelector('[data-ait-barcode-dialog]');
    if (!dialog) return;
    update(root);
    if (root.querySelector('[data-ait-barcode-open]')?.hidden) return;
    if (dialog.open) return;
    dialog.classList.remove('ait-barcode__closing', 'ait-barcode__swipe-closing', 'ait-barcode__dragging', 'ait-barcode__snap-back', 'ait-barcode__opened');
    dialog.style.removeProperty('--ait-barcode-drag-y');
    if (typeof dialog.showModal === 'function') {
      try { dialog.showModal(); }
      catch (_) { dialog.setAttribute('open', ''); dialog.classList.add('ait-barcode__fallback'); }
    } else { dialog.setAttribute('open', ''); dialog.classList.add('ait-barcode__fallback'); }
    window.setTimeout(() => { if (dialog.open) dialog.classList.add('ait-barcode__opened'); }, 330);
  }
  function close(dialog) {
    if (!dialog || dialog.classList.contains('ait-barcode__closing')) return;
    const actuallyClose = () => {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
      dialog.classList.remove('ait-barcode__fallback', 'ait-barcode__closing', 'ait-barcode__dragging', 'ait-barcode__snap-back', 'ait-barcode__swipe-closing', 'ait-barcode__opened');
      dialog.style.removeProperty('--ait-barcode-drag-y');
    };
    const animate = dialog.open && window.matchMedia('(max-width:749px) and (prefers-reduced-motion:no-preference)').matches;
    if (!animate) { actuallyClose(); return; }
    dialog.classList.add('ait-barcode__closing');
    window.setTimeout(actuallyClose, 230);
  }
  // Mobile drag handle: drag down to dismiss, short drags spring back.
  let activeDrag = null;
  function clearDrag(dialog) {
    dialog.classList.remove('ait-barcode__dragging', 'ait-barcode__snap-back', 'ait-barcode__swipe-closing');
    dialog.style.removeProperty('--ait-barcode-drag-y');
  }
  function finishSwipe(dialog) {
    if (!dialog.open) { clearDrag(dialog); return; }
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
    dialog.classList.remove('ait-barcode__fallback','ait-barcode__opened','ait-barcode__closing');
    clearDrag(dialog);
  }
  document.addEventListener('pointerdown', event => {
    if (!(event.target instanceof Element)) return;
    const handle = event.target.closest('[data-ait-barcode-handle]');
    if (!handle || event.button !== 0) return;
    const dialog = handle.closest('[data-ait-barcode-dialog]');
    if (!dialog?.open || dialog.classList.contains('ait-barcode__closing')) return;
    activeDrag = {id:event.pointerId, dialog, startY:event.clientY, move:0};
    dialog.style.setProperty('--ait-barcode-drag-y','0px');
    dialog.classList.remove('ait-barcode__snap-back');
    dialog.classList.add('ait-barcode__dragging','ait-barcode__opened');
    try { handle.setPointerCapture(event.pointerId); } catch (_) {}
  });
  document.addEventListener('pointermove', event => {
    const drag=activeDrag;
    if (!drag || event.pointerId!==drag.id) return;
    drag.move=Math.max(0,event.clientY-drag.startY);
    drag.dialog.style.setProperty('--ait-barcode-drag-y',Math.round(drag.move)+'px');
    if(event.cancelable) event.preventDefault();
  }, {passive:false});
  function endDrag(event) {
    const drag=activeDrag;
    if(!drag || event.pointerId!==drag.id) return;
    activeDrag=null;
    const dialog=drag.dialog;
    if(!dialog.open){clearDrag(dialog);return;}
    const distance=drag.move;
    if(distance > Math.min(115,dialog.getBoundingClientRect().height*.22)){
      // Transition from the dragged position to the bottom of the screen.
      dialog.classList.remove('ait-barcode__dragging');
      dialog.classList.add('ait-barcode__swipe-closing');
      window.setTimeout(()=>finishSwipe(dialog),235);
    } else {
      dialog.classList.remove('ait-barcode__dragging');
      dialog.classList.add('ait-barcode__snap-back');
      requestAnimationFrame(()=>dialog.style.setProperty('--ait-barcode-drag-y','0px'));
      window.setTimeout(()=>{
        dialog.classList.remove('ait-barcode__snap-back');
        dialog.style.removeProperty('--ait-barcode-drag-y');
      },220);
    }
  }
  document.addEventListener('pointerup',endDrag);
  document.addEventListener('pointercancel',endDrag);

  // Delegate events from document: Shopify can replace sections without re-running inline scripts.
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-ait-barcode-open]');
    if (button) {
      event.preventDefault();
      const root = button.closest('[data-ait-barcode]');
      if (root) open(root);
      return;
    }
    const dismiss = event.target.closest('[data-ait-barcode-close]');
    if (dismiss) { event.preventDefault(); close(dismiss.closest('dialog')); return; }
    const dialog = event.target.closest('[data-ait-barcode-dialog]');
    if (dialog && event.target === dialog) {
      const b = dialog.getBoundingClientRect();
      if (event.clientX < b.left || event.clientX > b.right || event.clientY < b.top || event.clientY > b.bottom) close(dialog);
    }
  });
  document.addEventListener('cancel', event => {
    if (event.target?.matches?.('[data-ait-barcode-dialog]')) {
      event.preventDefault();
      close(event.target);
    }
  }, true);
  document.addEventListener('variant:update', event => {
    const id = String(event.detail?.resource?.id || '');
    if (!id) return;
    document.querySelectorAll('[data-ait-barcode]').forEach(root => {
      const variants = getVariants(root);
      if (variants[id]) update(root, id);
    });
  });
  document.addEventListener('change', event => {
    if (event.target?.closest?.('[data-testid="product-information"]')) {
      setTimeout(() => document.querySelectorAll('[data-ait-barcode]').forEach(root => update(root)), 120);
    }
  });
  window.addEventListener('popstate', () => {
    document.querySelectorAll('[data-ait-barcode]').forEach(root => update(root));
  });
  function refresh() { document.querySelectorAll('[data-ait-barcode]').forEach(root => update(root)); }
  function bootstrapBarcode() {
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootstrapBarcode, {once:true});
  else bootstrapBarcode();
})();